import styled from "styled-components";

export const HeaderStyled = styled.header`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  position: fixed;

  button {
    color: #fff;
    background: #222324;
    font-weight: 600;
    border: 0;
    border-radius: 9999px;
    padding: 10px 15px;
    cursor: pointer;
    font-size: 15px;
    margin-right: 40px;

    &:active {
      transition: 0.4s all;
      transform: translateY(2px);
    }
  }
`;

export const CustomerInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;

  p {
    font: 500 1rem "Roboto", sans-serif;
    color: #fff;
    margin-right: 40px;
    text-align: center;
  }
`;
